import { Injectable } from '@angular/core';
import { AppNotificationUtilClass, BundleLineInDataProvider } from '@monorepo/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError, finalize, take } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { TBundleLineInActionType } from './bundle-line-in-db.models';
import * as BundleLineInActions from './bundle-line-in-db.actions';
import { InputAppAPIHelperUtil } from '@monorepo/utils';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class BundleLineInEffects {
  constructor(
    private actions$: Actions,
    private bundleLineInDataProvider: BundleLineInDataProvider,
    private appNotificationUtilClass: AppNotificationUtilClass,
    private inputAppAPIHelperUtil: InputAppAPIHelperUtil,
    private translate: TranslateService,
  ) {}

  async showErrorModal(errorTxt: string, errorHeader: string = 'Error') {
    return this.inputAppAPIHelperUtil.showPopup(errorHeader, errorTxt, undefined, 'rqc-transactions-error');
  }

  getTransactionLogs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TBundleLineInActionType.GetTransactionLog),
      switchMap((action: BundleLineInActions.GetTransactionLog) =>
        from(this.appNotificationUtilClass.presentLoading('Loading Transaction Log...')).pipe(
          take(1),
          map((loaderEl) => {
            return [loaderEl, action] as const;
          }),
        ),
      ),

      switchMap(([loaderEl, action]) => {
        return this.bundleLineInDataProvider.getBundleLineInTransactionLog(action.payload).pipe(
          finalize(() => {
            this.appNotificationUtilClass.dismissLoadingV2(loaderEl);
          }),
          map((res) => {
            return new BundleLineInActions.GetTransactionLogSuccess(res);
          }),
          catchError((err: HttpErrorResponse) => {
            this.inputAppAPIHelperUtil.handleHttpErrors(err);
            return of(new BundleLineInActions.GetTransactionLogFailure());
          }),
        );
      }),
    ),
  );

  getActivityLogs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TBundleLineInActionType.GetActivityLog),
      switchMap((action: BundleLineInActions.GetActivityLog) =>
        from(this.appNotificationUtilClass.presentLoading('Loading Activity Log...')).pipe(
          take(1),
          map((loaderEl) => {
            return [loaderEl, action] as const;
          }),
        ),
      ),

      switchMap(([loaderEl, action]) => {
        return this.bundleLineInDataProvider.getBundleLineInActivityLog(action.payload).pipe(
          finalize(() => {
            this.appNotificationUtilClass.dismissLoadingV2(loaderEl);
          }),
          map((res) => {
            return new BundleLineInActions.GetActivityLogSuccess(res);
          }),
          catchError((err: HttpErrorResponse) => {
            this.inputAppAPIHelperUtil.handleHttpErrors(err);
            return of(new BundleLineInActions.GetActivityLogFailure());
          }),
        );
      }),
    ),
  );
  getRestoreCount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TBundleLineInActionType.GetRestoreCount),

      switchMap((action: BundleLineInActions.GetRestoreCount) => {
        return this.bundleLineInDataProvider.fetchBundleLineInRestoreCounts(action.payload).pipe(
          map((res) => {
            return new BundleLineInActions.GetRestoreCountSuccess(res);
          }),
          catchError((err: HttpErrorResponse) => {
            this.inputAppAPIHelperUtil.handleHttpErrors(err);
            return of(new BundleLineInActions.GetRestoreCountFailure());
          }),
        );
      }),
    ),
  );
}
